import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddConfigCategoryMutationVariables = Types.Exact<{
  input: Types.AddConfigCategoryInput;
}>;


export type AddConfigCategoryMutation = { __typename?: 'Mutation', addConfigCategory: { __typename?: 'ConfigCategoryPayload', configCategory?: { __typename?: 'ConfigCategoryStateData', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, eachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateConfigCategoryMutationVariables = Types.Exact<{
  input: Types.UpdateConfigCategoryInput;
}>;


export type UpdateConfigCategoryMutation = { __typename?: 'Mutation', updateConfigCategory: { __typename?: 'ConfigCategoryPayload', configCategory?: { __typename?: 'ConfigCategoryStateData', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, eachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateConfigCategoryMutationVariables = Types.Exact<{
  input: Types.ActivateConfigCategoryInput;
}>;


export type ActivateConfigCategoryMutation = { __typename?: 'Mutation', activateConfigCategory: { __typename?: 'ConfigCategoryPayload', configCategory?: { __typename?: 'ConfigCategoryStateData', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, eachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateConfigCategoryMutationVariables = Types.Exact<{
  input: Types.DeactivateConfigCategoryInput;
}>;


export type DeactivateConfigCategoryMutation = { __typename?: 'Mutation', deactivateConfigCategory: { __typename?: 'ConfigCategoryPayload', configCategory?: { __typename?: 'ConfigCategoryStateData', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, eachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddSizeUomToConfigCategoryMutationVariables = Types.Exact<{
  input: Types.AddSizeUomToConfigCategoryInput;
}>;


export type AddSizeUomToConfigCategoryMutation = { __typename?: 'Mutation', addSizeUomToConfigCategory: { __typename?: 'ConfigCategoryPayload', configCategory?: { __typename?: 'ConfigCategoryStateData', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, eachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConfigCategoryStateFragment = { __typename?: 'ConfigCategoryStateData', configCategoryId: string, code: string, name: string, defaultSizeUomCode: string, eachesPerUnit?: number | null, sizeUomCodes: Array<string>, containerConfigIds: Array<string>, status: Types.ConfigCategoryStatus };

export const ConfigCategoryStateFragmentDoc = new TypedDocumentString(`
    fragment ConfigCategoryState on ConfigCategoryStateData {
  configCategoryId
  code
  name
  defaultSizeUomCode
  eachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}
    `, {"fragmentName":"ConfigCategoryState"});
export const AddConfigCategoryDocument = new TypedDocumentString(`
    mutation AddConfigCategory($input: AddConfigCategoryInput!) {
  addConfigCategory(input: $input) {
    configCategory {
      ...ConfigCategoryState
    }
    errors {
      code
      message
    }
  }
}
    fragment ConfigCategoryState on ConfigCategoryStateData {
  configCategoryId
  code
  name
  defaultSizeUomCode
  eachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}`);
export const UpdateConfigCategoryDocument = new TypedDocumentString(`
    mutation UpdateConfigCategory($input: UpdateConfigCategoryInput!) {
  updateConfigCategory(input: $input) {
    configCategory {
      ...ConfigCategoryState
    }
    errors {
      code
      message
    }
  }
}
    fragment ConfigCategoryState on ConfigCategoryStateData {
  configCategoryId
  code
  name
  defaultSizeUomCode
  eachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}`);
export const ActivateConfigCategoryDocument = new TypedDocumentString(`
    mutation ActivateConfigCategory($input: ActivateConfigCategoryInput!) {
  activateConfigCategory(input: $input) {
    configCategory {
      ...ConfigCategoryState
    }
    errors {
      code
      message
    }
  }
}
    fragment ConfigCategoryState on ConfigCategoryStateData {
  configCategoryId
  code
  name
  defaultSizeUomCode
  eachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}`);
export const DeactivateConfigCategoryDocument = new TypedDocumentString(`
    mutation DeactivateConfigCategory($input: DeactivateConfigCategoryInput!) {
  deactivateConfigCategory(input: $input) {
    configCategory {
      ...ConfigCategoryState
    }
    errors {
      code
      message
    }
  }
}
    fragment ConfigCategoryState on ConfigCategoryStateData {
  configCategoryId
  code
  name
  defaultSizeUomCode
  eachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}`);
export const AddSizeUomToConfigCategoryDocument = new TypedDocumentString(`
    mutation AddSizeUomToConfigCategory($input: AddSizeUomToConfigCategoryInput!) {
  addSizeUomToConfigCategory(input: $input) {
    configCategory {
      ...ConfigCategoryState
    }
    errors {
      code
      message
    }
  }
}
    fragment ConfigCategoryState on ConfigCategoryStateData {
  configCategoryId
  code
  name
  defaultSizeUomCode
  eachesPerUnit
  sizeUomCodes
  containerConfigIds
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddConfigCategory: build.mutation<AddConfigCategoryMutation, AddConfigCategoryMutationVariables>({
      query: (variables) => ({ document: AddConfigCategoryDocument, variables })
    }),
    UpdateConfigCategory: build.mutation<UpdateConfigCategoryMutation, UpdateConfigCategoryMutationVariables>({
      query: (variables) => ({ document: UpdateConfigCategoryDocument, variables })
    }),
    ActivateConfigCategory: build.mutation<ActivateConfigCategoryMutation, ActivateConfigCategoryMutationVariables>({
      query: (variables) => ({ document: ActivateConfigCategoryDocument, variables })
    }),
    DeactivateConfigCategory: build.mutation<DeactivateConfigCategoryMutation, DeactivateConfigCategoryMutationVariables>({
      query: (variables) => ({ document: DeactivateConfigCategoryDocument, variables })
    }),
    AddSizeUomToConfigCategory: build.mutation<AddSizeUomToConfigCategoryMutation, AddSizeUomToConfigCategoryMutationVariables>({
      query: (variables) => ({ document: AddSizeUomToConfigCategoryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddConfigCategoryMutation, useUpdateConfigCategoryMutation, useActivateConfigCategoryMutation, useDeactivateConfigCategoryMutation, useAddSizeUomToConfigCategoryMutation } = injectedRtkApi;
